import { css, createGlobalStyle } from 'styled-components';
import { Colors, pxToRem } from '@maskott/tactileo.designsystem';
import {
  FOOTER_BOTTOM_HEIGHT,
  FOOTER_TOP_HEIGHT,
} from 'components/parts/Footer/Footer.style';

const GlobalStyle = createGlobalStyle`
  *{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    list-style-type: none;

    iframe {
      border: none;
    }
  }

  #root {
    height: 100vh;
  }

  html {
      background: ${(p) =>
        Colors(p.theme.colors.neutral, p.theme.colors.lightness.light100, 1)};
      color: ${(p) =>
        Colors(p.theme.colors.neutral, p.theme.colors.lightness.light30, 1)};
      filter: invert(${(p) => Number(p.invertColorsFlag)});

    body {
      overflow: hidden;
      box-sizing: border-box;
      
      & > div[role="menu"] {
        right: 0;
        overflow-y: auto;
        height: unset;
        ${(p) => {
          if (p.isMobile) {
            return css`
              top: ${pxToRem(FOOTER_TOP_HEIGHT(p.size))};
              bottom: 0;
            `;
          } else {
            return css`
              top: 0px;
              bottom: ${pxToRem(FOOTER_BOTTOM_HEIGHT)};
            `;
          }
        }}
        li[role="option"] {
          cursor: pointer;
        }
      }
      
      .readyToBeRead{
         ${(p) => {
           if (p.theme.voiceassistant) {
             return `
              cursor: url(${p.theme.voiceassistant.cursorPath}),pointer;
            `;
           }
         }}
        &:hover{
          background: ${(p) =>
            Colors(
              p.theme.colors.tertiary,
              p.theme.colors.lightness.light95,
              1,
            )};
        }
      }
      
      .isReading{
          background-color: #fbff92;
          &:hover{
            background-color: #fbff92;
          }
      }

      .alignLeft{
          float: left;
      }

      .alignRight{
        float: right;
      }

      .alignCenter{
        margin: 0 auto;
      }
    }

    @media print {
      ul { page-break-inside:auto }
      li { page-break-inside:avoid; page-break-after:auto }
    }
  }
`;

export default GlobalStyle;
